var _rect, _path, _path2, _rect2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPub = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  fill: "none",
  viewBox: "0 0 40 40",
  ref: ref
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 30,
  height: 36,
  x: 9,
  y: 2,
  fill: "#EBEBEB",
  rx: 2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#C8C8C8",
  d: "M9 29h30v7a2 2 0 0 1-2 2H11a2 2 0 0 1-2-2z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#DDD",
  d: "M30 29V2h7a2 2 0 0 1 2 2v25z"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 28,
  height: 19.5,
  x: 1,
  y: 11,
  fill: "#EE7623",
  rx: 2
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M5.76 17.61h2.47q.81 0 1.33.18.53.18.83.48t.42.7q.12.39.12.82 0 .46-.12.88t-.43.74q-.3.31-.82.5-.52.18-1.31.18h-1.3v2.66H5.76zm2.46 3.47q.46 0 .75-.09.3-.09.47-.25a.87.87 0 0 0 .23-.4q.07-.23.07-.52 0-.3-.07-.52a.8.8 0 0 0-.25-.38q-.17-.15-.47-.23a2.9 2.9 0 0 0-.74-.08H6.95v2.47zm4.958-3.47v4.28q0 1.01.36 1.51.37.49 1.24.49.86 0 1.21-.49.36-.5.36-1.51v-4.28h1.21v4.28q0 .83-.2 1.41-.2.57-.57.94-.37.36-.88.52-.51.17-1.14.17-1.37 0-2.08-.73-.71-.74-.71-2.34v-4.25zm5.795 0h2.47q.78 0 1.28.15.5.14.79.4.3.25.41.6.11.34.11.73 0 .45-.2.84-.2.38-.73.63.34.15.56.34t.35.41q.13.21.18.45a2.44 2.44 0 0 1-.09 1.3 1.6 1.6 0 0 1-.44.68 2.3 2.3 0 0 1-.81.45q-.5.16-1.23.16h-2.65zm2.61 2.93q.71 0 .99-.26t.28-.75q0-.51-.33-.73-.32-.23-1.12-.23h-1.26v1.97zm0 3.24q.43 0 .71-.08a1.06 1.06 0 0 0 .45-.23q.17-.15.24-.36t.07-.47q0-.54-.31-.82-.3-.29-1.05-.29h-1.55v2.25z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPub);
export default ForwardRef;